/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import trans from "../../../../utils";
import TrackedSelectedRows from "./TrackedSelectedRows";
import { SpeedUnit } from "../../../../JsHelpers/PlatformUnits";
import { useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { Tag } from "antd";
export default function TrackedSelectedDetails({ details, device, position }) {
	const lang = localStorage.getItem("lang") || "en";
	const truncateItem = (text) => {
		const maxLength = 25;
		return text?.length > maxLength
			? text.substring(0, maxLength) + "..."
			: text;
	};
	const inf = useSelector((state) => state.users.user);
	const [geoCode, setGeoCode] = useState(false);
	const fetchGeoCodePosition = async (lat, lon) => {
		try {
			const response = await axios.get(
				`https://nominatim.openstreetmap.org/reverse.php?lat=${lat}&lon=${lon}&zoom=18&format=jsonv2`,
			);
			setGeoCode(`${response.data.display_name}`);
			return `${response.data.display_name}`;
		} catch (error) {
			toast.error(trans("Error fetching geocode position:"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};
	const type = (motion, ignition, protocol) => {
		if (protocol !== "osmand") {
			if (motion && ignition) {
				return "Moving";
			} else if (!motion && ignition) {
				return "Idle";
			} else if (!motion && !ignition) {
				return "Parking";
			}
		} else {
			if (motion) {
				return "Moving";
			} else if (!motion) {
				return "Parking";
			}
		}
	};
	const typeColors = {
		Moving: "green",
		Parking: "default",
		Idle: "orange",
	};
	return (
		<>
			<div className="object-selected-details">
				<div className="flex-center mb-2">
					<img src={`${process.env.PUBLIC_URL}/assets/Car.svg`} alt="car" />
					<div className={`${lang === "en" ? "ms-3" : "me-3"}`}>
						<div className="fs-16 fw-600 neutral-700" title={details?.name}>
							{truncateItem(details?.name)}
						</div>
						<div className="fs-14 fw-400 neutral-500">
							{details?.plateNumber}
						</div>
					</div>
				</div>
				<TrackedSelectedRows title={trans("IMEI")} item={details?.imei} />
				<TrackedSelectedRows
					title={trans("SIM Number")}
					item={details?.simNumber}
				/>
				{/* <TrackedSelectedRows title={trans("Device Id")} item={details?.imei} /> */}
				<TrackedSelectedRows
					title={trans("Car Activity")}
					item={
						<Tag
							color={
								typeColors[
									type(
										position?.attributes?.motion,
										position?.attributes?.ignition,
										position?.protocol,
									)
								]
							}
						>
							{trans(
								type(
									position?.attributes?.motion,
									position?.attributes?.ignition,
									position?.protocol,
								),
							)}
						</Tag>
					}
				/>
				<TrackedSelectedRows
					title={trans("Speed")}
					item={SpeedUnit(device?.speed, inf.attributes?.speedUnit || "kn")}
				/>
				<div
					className="object-status-details cursor"
					onClick={() => {
						const lat = position ? position.latitude : inf.latitude;
						const lon = position ? position.longitude : inf.longitude;
						fetchGeoCodePosition(lat, lon);
					}}
				>
					<TrackedSelectedRows
						title={trans("Location")}
						item={geoCode ? geoCode : trans("Get current address")}
						// eslint-disable-next-line react/style-prop-object
						style="text-primary"
					/>
				</div>
			</div>
		</>
	);
}
